<template>
  <div class="d-timetal__container">
    <div class="d-guides">
      <StilGuides :video-id="'etaeiteazYM?start=67'"
                  textForLink="Guide: Se videoguide for Personalets alder og køn"></StilGuides>
      <p class="italic">Bemærk: Det er de personaler, som er ansat på skolen pr. 5. september 2022, der skal
        indberettes.
        <br>Personale der ikke skal indberettes sættes til "Ingen undervisningsopgaver (ikke indberet)"</p>
    </div>
    <div class="d-filters">
      <div class="d-filters__filter" :class="{'d-filters__filter--active': activeFilter === 0}"
           @click="activeFilter = 0">Alle
        <div class="d-pill">{{ usersWithVProps.length }}</div>
      </div>
      <div class="d-filters__filter" :class="{'d-filters__filter--active': activeFilter === 1}"
           @click="activeFilter = 1">Ikke udfyldte
        <div class="d-pill">{{ unfilledUsers.length }}</div>
      </div>
    </div>
    <table class="d-table">
      <thead>
      <tr>
        <th class="d-table__name">Navn</th>
        <th>Mand / Kvinde</th>
        <th>Fødselsdato</th>
        <th>Stilling</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(user, userIdx) in filteredUsersWithVProps" :key="user.id">
        <td>{{ user.name }}</td>
        <td>
          <select class="timetal-select" v-model="user.gender"
                  @change="updateUser(user, 'gender', $event.target.value)">
            <option value="female">Kvinde</option>
            <option value="male">Mand</option>
          </select>
        </td>
        <td>
          <input type="date" :value="user.v_birthday" @blur="updateUser(user, 'dob', $event.target.value)">
        </td>
        <td>
          <select class="timetal-select" v-model="user.v_stil_stilling"
                  @change="updateUser(user, 'stil_stilling', $event.target.value)">
            <option value="LA">Lærer</option>
            <option value="BH">Børnehaveklasseleder</option>
            <option value="PA">Pædagog</option>
            <option value="LE">Leder</option>
            <option value="AN">Andre med undervisningsopgaver</option>
            <option value="undtaget">Ingen undervisningsopgaver (ikke indberet)</option>
          </select>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import moment from 'moment'
import StilGuides from './StilGuides'

export default {
  components: {StilGuides},
  mixins: [clickaway],
  data () {
    return {
      theSelectMonth: null,
      activeFilter: 0
    }
  },
  computed: {
    schoolId () {
      return this.$route.params.school_id
    },
    users () {
      return this.$store.getters.usersSortedOnName
    },
    usersWithVProps () {
      return this.users.map(user => {
        let birthday = null
        if (user.dob && user.dob.length > 6) {
          birthday = user.dob
        }
        this.$set(user, 'v_birthday', birthday)
        let stilStilling = null
        if (user.custom_data && user.custom_data['schools'] && user.custom_data['schools'][this.schoolId] && user.custom_data['schools'][this.schoolId]['stilling']) {
          stilStilling = user.custom_data['schools'][this.schoolId]['stilling']
        }
        this.$set(user, 'v_stil_stilling', stilStilling)
        return user
      })
    },
    unfilledUsers () {
      return this.usersWithVProps.filter(user => !user.gender || !user.v_birthday || !user.v_stil_stilling)
    },
    filteredUsersWithVProps () {
      if (this.activeFilter === 0) {
        return this.usersWithVProps
      } else {
        return this.unfilledUsers
      }
    }
  },
  methods: {
    updateUser (user, change, val) {
      let customData = user.custom_data
      let errors = false
      let changes = {}
      changes[change] = val
      if (change === 'stil_stilling') {
        if (!customData['schools']) {
          customData.schools = {[this.schoolId]: {'stilling': val}}
        }
        if (customData['schools'] && !customData['schools'][this.schoolId]) {
          customData['schools'][this.schoolId] = {'stilling': val}
        }
        if (customData['schools'] && customData['schools'][this.schoolId]) {
          customData['schools'][this.schoolId]['stilling'] = val
        }
        changes['custom_data'] = customData
      }
      if (change === 'dob') {
        if (!moment(val).isValid() || moment(val).isAfter(moment())) {
          eventbus.toast = {text: 'Ugyldig fødselsdato', success: false}
          errors = true
          const originalDob = JSON.parse(JSON.stringify(user.dob))
          user.dob = null
          user.dob = originalDob
        }
        changes[change] = val
      }
      if (errors) {
        return
      }
      docendo.updateUsers(this.schoolId, user.id, changes, success => {
        this.$store.commit('updateSchoolUser', success)
      }, failure => {
        eventbus.toast = {text: 'Noget gik galt', success: false}
      })
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-table__name {
  width: 250px;
}

.uppercase {
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.d-timetal__container {
  padding: 2rem 1rem;
  border: 1px solid #d8d8d8;
  width: 100%;
  max-width: 1440px;
  min-width: 1100px;
  border-radius: 4px;
}

.d-table {
  width: 100%;
  border: 1px solid #d8d8d8;
  border-collapse: collapse;
  border-radius: 4px;
}

.d-table thead {
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #728195;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
}

.d-table thead th {
  padding: 0.5rem 1rem;
  text-align: left;
}

.d-table tbody tr {
  width: 100%;
  background: #f9fafb;
  border-bottom: 1px solid #e3e8ee;
}

.d-table tbody tr:nth-child(odd) {
  background: #ffffff;
}

.d-table tbody tr:hover {
  background: aliceblue;
}

.d-table tbody tr td {
  padding: 0.5rem 1rem;
  text-align: left;
  width: 75px !important;
}

.birthday {
  display: inline-flex;
  border: 1px solid #acb6be;
  border-radius: 4px;
}

.birthday input[type="text"] {
  border: none;
  border-radius: 4px 0 0 4px;
  border-right: 1px dashed #888888;
  text-align: center;
  width: 60px;
}

.birthday input[type="text"]:focus {
  border-color: var(--blue);
}

.birthday div:last-child input[type="text"] {
  margin-right: 0;
  border-right: 0 !important;
  width: 60px;
  border-radius: 0 4px 4px 0;
}

.d-number {
  text-align: right;
}

select.timetal-select,
input[type="date"] {
  height: 36px;
  background-color: #ffffff;
  border-radius: 4px;
  min-width: 100px;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
  border: 1px solid #d8d8d8;
}

input[type="date"] {
  padding: 9px;
  width: 150px;
}

.d-filters {
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
}

.d-filters__filter {
  padding: 0.5rem 1.5rem;
  border: 1px solid #d8d8d8;
  border-width: 1px 1px 0 1px;
  margin-right: 1rem;
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: bold;
}

.d-filters__filter.d-filters__filter--active {
  background: #f6f9fc;
  color: var(--primary)
}

.d-filters__filter.d-filters__filter--active > .d-pill {
  background: #e0e7ff;
  color: var(--primary);
  border-color: transparent;
}

.d-filters__filter > .d-pill {
  margin-left: 1rem;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  color: #111827;
  padding: 4px 8px;
  font-weight: bold;
  background: transparent;
  border: 1px solid rgba(204, 204, 204, 0.75);
  font-size: 11px;
}

.d-guides {
  border: 1px solid rgba(204, 204, 204, 0.75);
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// GrundskoleIndberetningUsers.vue?413599c8